import React from 'react';
import UserAvatar from './UserAvatar';
import locale from '../locale';

const styles = {
  main: {
    marginTop:32,
    marginBottom:16,
  },
  avatar: {
    marginTop:8,
    marginRight:8,
  }
}


const TickInfo = ({list=[]})=>{
  let text = (locale.lang === 'ch') ? '有'+list.length+'個人完攀這條路線' :
                                    list.length + ' people ticked this route'
  return (
      <div style={styles.main}>
      <div>{text}</div>
      {list.map(uid=><UserAvatar key={uid} style={styles.avatar} uid={uid}/>)}
      </div>
    )
}

export default TickInfo



/** WEBPACK FOOTER **
 ** ./src/app/components/TickInfo.js
 **/